import { TranslateResult } from 'vue-i18n';
import { i18n } from '@/main';

export const periodFormatter = (period): string => {
  const isPeriod = period && period?.startYmdt && period?.endYmdt;
  return isPeriod ? `${period.startYmdt} ~ ${period.endYmdt}` : '-';
};

export const getAnchorHTML = (text: TranslateResult, classNames?: string): string =>
  `<a href="javascript:;" ${classNames ? `class='${classNames}'` : 'class="underline"'}>${text}</a>`;

export const getDeleteHTML = () => `<button class="btnDel-sm">${i18n.t('PRODUCT.ICON.HEADER_DELETE')}</button>`;

export const getSpanHTML = (value: string, type = '', className = 'underline') => {
  const style = className === 'underline' ? 'text-decoration: underline; cursor: pointer;' : null;
  return `<span class="${className}" data-type="${type}" style="${style}">${value}</span>`;
};

export const getButtonHTML = (value: string, type = '', className = 'double_click_allow type-white') => {
  return `<button data-type="${type}" class="${className}">${value}</button>`;
};

export const emptyValueFormatter = (value, valueToDisplay?): string => (value ? valueToDisplay || value : '-');

export const getHighlightHTML = (value): string => `<span class="highlight">${value}</span>`;
